import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import DoctorList from "./doctorList";
import {
  getAppointments,
  getPastAppointments,
  getUpcomingAppointments,
} from "../../lib/api";
import { format } from "date-fns";
import { cn, useAppointmentsMiscellaneous } from "../../shared/utils";
import {
  AddVitalIcon,
  CamIcon,
  ClockIcon,
  HospitalIcon,
  VideoConsultation,
} from "../../shared/svgIcon";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { useStore } from "../../store";

const AppointmentList = () => {
  let navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const setSelectedAppointment = useStore((state) => state.setAppointment);
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();


  const fetchCancelledAppointments = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const query_parameters = {
        // "user_id": "654894739c4dd83f4ba079d0",
        // "organization_id": "654515714b1c8f293f4c014b",
        consumer_id: patientId,
        status: "canceled",
      };
      const res = await getAppointments(query_parameters);
      // console.log(res, "res");
      const appointments = res?.data?.result;
      setAppointments(appointments);
      setLoading(false);
      // console.log(appointments, "ecg");
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchPastAppointments = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const query_parameters = {
        // "user_id": "654894739c4dd83f4ba079d0",
        // "organization_id": "654515714b1c8f293f4c014b",
        consumer_id: patientId,
      };
      const res = await getPastAppointments(query_parameters);
      // console.log(res, "res");
      const appointments = res?.data?.result;
      setAppointments(appointments);
      setLoading(false);
      // console.log(appointments, "ecg");
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchUpcomingAppointments = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const query_parameters = {
        // "user_id": "654894739c4dd83f4ba079d0",
        // "organization_id": "654515714b1c8f293f4c014b",
        consumer_id: patientId,
      };
      const res = await getUpcomingAppointments(query_parameters);
      // console.log(res, "res");
      const appointments = res?.data?.result;
      setAppointments(appointments);
      setLoading(false);
      // console.log(appointments, "ecg");
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpcomingAppointments();
  }, []);
  const gotoSchedule = () => {
    // console.log("navigate");
    navigate("/schedule");
  };
  const gotoDetail = async (id, tab) => {
    // console.log("navigate");
    if (tab == "upcoming") {
      const selectedAppointment = appointments.filter((e) => e.id == id)[0];
      await setSelectedAppointment(selectedAppointment);
      navigate(`/appointmentDetail/${id}`);
    }
  };

  const startCall = (e) => {
    sessionStorage.setItem("selectedAppointment", JSON.stringify(e));
    navigate("/videoCall");
  };
  const getStatus = (key) => {

    return appointmentsMisc?.data?.result?.appointment_status_types?.filter(
      (e) => e.key === key
    )[0]?.label;
  };
  const handleTabChange = (e) => {
    console.log(e, "tab");
    switch (e) {
      case "past":
        fetchPastAppointments();
        break;
      case "upcoming":
        fetchUpcomingAppointments();
        break;
      case "cancelled":
        fetchCancelledAppointments();
        break;
      default:
        break;
    }
  };
  const AppointmentCard = ({
    date,
    doctorName,
    specialities,
    qualifications,
    type,
    status,
    avatar_url,
    tab,
    id,
  }) => {
    return (
      <div
        className={`${
          tab == "upcoming" ? "bg-[#EBEDFF]" : "bg-[#F5F5F5]"
        } border shadow rounded-[18px] p-4   flex flex-col flex-1 bg-[#EBEDFF] `}
        onClick={(e) => gotoDetail(id, tab)}
      >
        <div className="flex items-start  mb-2 flex-col ">
          {/* <div className="text-sm text-zinc-600  mb-2">Appointment date</div> */}
          <div className="text-sm font-semibold flex items-center text-slate-700 justify-between w-full ">
            {/* <ClockIcon className="mr-2" />
            <p className="pr-1">{format(new Date(date), "MMM")}</p>
            <p className="">{format(new Date(date), "dd")}</p>,
            <p className="pr-1">{format(new Date(date), "yyyy")}</p>
            <p className="pl-3 ">{format(new Date(date), "EEE")}</p>, */}
            <div className="border rounded-xl flex flex-col w-[50px] h-[50px] overflow-hidden">
          <p className="bg-primary text-white px-2   text-sm rounded-t-xl flex justify-center items-center">{format(new Date(date), "MMM")}</p>
          <p className="bg-white px-2   rounded-b-xl text-xl  flex justify-center items-center">{format(new Date(date), "dd")}</p>
          </div>
          <div className="flex flex-col w-[50px] h-[50px] items-center">
          <p className="pl-1 pr-1">{format(new Date(date), "h:mm")}</p>
            <p className="pl-1 pr-1">{format(new Date(date), " a")}</p>
          </div>
          </div>
          
        </div>
        <div className="w-full h-[0px] border-b-[1px] border-indigo-200 mb-2"></div>
        {/* <hr className="mb-2 bg-indigo-200" /> */}
        <div className="flex flex-1   justify-between ">
          <div className="flex ">
            <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
              {avatar_url ? (
                <img
                  className="w-full h-full object-cover"
                  src={avatar_url}
                  alt={doctorName}
                />
              ) : (
                <img
                  className="w-full h-full object-cover"
                  src={"../../../images/user.svg"}
                  alt={doctorName}
                />
              )}
            </div>
          </div>
          <div className="flex  flex-col flex-1 pl-2">
            <div className="flex flex-col px-2 py-1 ">
              <div className="font-semibold text-lg text-slate-700">
                {doctorName}
              </div>
              <div className="text-base text-zinc-600 ">
                {qualifications &&
                  qualifications.map((qualification, index) => (
                    <div key={index}>
                      <span
                        key={index}
                        className="text-neutral-500 text-sm font-normal"
                      >
                        {qualification}
                      </span>{" "}
                      {index < qualifications.length - 1 && (
                        <span className="pr-1">,</span>
                      )}
                    </div>
                  ))}
                {specialities &&
                  specialities.map((specialty, index) => (
                    <div key={index}>
                      <span className="pr-1">,</span>
                      <span
                        key={index}
                        className="text-neutral-500 text-sm font-normal"
                      >
                        {specialty?.name}
                      </span>{" "}
                      {index < specialities.length - 1 && (
                        <span className="pr-1">,</span>
                      )}
                    </div>
                  ))}
              </div>
            </div>
            {tab == "upcoming" && (
              <div className="flex flex-1  gap-4 px-2 py-1">
                <div className="flex flex-col flex-1 justify-between">
                  <div className="font-semibold text-base text-slate-700 mb-2">
                    Type
                  </div>
                  <div
                    className={`flex items-center text-sm text-white py-1 px-2 rounded-xl border w-[115px] ${
                      type == "virtual_visit"
                        ? "bg-green-500  border-green-500"
                        : "bg-orange-500 border-orange-500"
                    }`}
                  >
                    {type == "virtual_visit" ? (
                      <CamIcon height={"20px"} width={"20px"} />
                    ) : (
                      <HospitalIcon height={"20px"} width={"20px"} />
                    )}{" "}
                    <p className="px-1 pl-2">
                      {type == "virtual_visit" ? "Video call" : "In Person"}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col  flex-1 justify-between">
                  <div className="font-semibold text-base text-slate-700 mb-2">
                    Status
                  </div>
                  <div className={` text-sm rounded-full py-1 text-slate-700`}>
                    {getStatus(status)}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="relative bg-white min-sh-screen ">
      <>
        {" "}
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" to="/Dashboard">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-base">My Appointment</h4>
              </div>
            </Link>
          </div>

          {/* <button
            onClick={gotoSchedule}
            className={cn(
              "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
              "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
              "h-9 px-4 py-2"
            )}
          >
            <span className="mr-1 text-lg leading-none">+</span>
            Add Appointment
          </button> */}
        </div>
        <div className="  pt-16 pb-1 px-4">
          <Tabs defaultValue="upcoming" onValueChange={handleTabChange}>
            <TabsList className="w-full  justify-start">
              <TabsTrigger value="upcoming" className="flex-1 text-sm">
                Upcoming
              </TabsTrigger>
              <TabsTrigger value="past" className="flex-1  text-sm">
                Past
              </TabsTrigger>
              <TabsTrigger value="cancelled" className="flex-1  text-sm">
                Cancelled
              </TabsTrigger>
            </TabsList>
            <TabsContent value="upcoming">
              <div
                className=" flex-1 overflow-scroll hideScroll   flex flex-col "
                style={{ height: "calc(100vh - 180px)" }}
              >
                {appointments.length > 0 && !isLoading && (
                  <div className=" gap-3 md:gap-3    sm:justify-normal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {appointments.map((e, index) => (
                      <AppointmentCard
                        key={index}
                        id={e?.id}
                        date={e?.start_time}
                        doctorName={`${e?.user?.name_prefix} ${e?.user?.profile?.first_name}
              ${e?.user?.profile?.middle_name}
              ${e?.user?.profile?.last_name}`}
                        specialities={e?.user?.specialities}
                        qualifications={e?.user?.qualifications}
                        type={e?.appointment_type}
                        status={e?.status}
                        tab="upcoming"
                      />
                    ))}
                  </div>
                )}
                {appointments.length == 0 && !isLoading && (
                  <div className=" flex flex-col  items-center flex-1">
                    <div>
                      <VideoConsultation width={"100px"} height={"150px"} />
                    </div>
                    <h1 className="text-xl font-bold mb-6">
                      No Appointments found
                    </h1>
                    {/* <p className="text-gray-400 text-base font-semibold m-4">
              Schedule your Appointment
           </p> */}
                    <button
                      className={cn(
                        "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                        "bg-secondary text-primary-foreground shadow hover:opacity-40",
                        "h-10 rounded-md px-8"
                      )}
                      onClick={gotoSchedule}
                    >
                      Schedule Appointment
                    </button>
                  </div>
                  //
                )}
                {isLoading && (
                  <div className=" relative ">
                    <div className=" gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                      {" "}
                      <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                        <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                        <div className="flex flex-col w-full">
                          <div className="m-2 w-full  bg-slate-200 h-4"></div>
                          <div className="m-2  w-full  bg-slate-200 h-4"></div>
                        </div>
                      </div>
                      <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                        <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                        <div className="flex flex-col w-full">
                          <div className="m-2 w-full  bg-slate-200 h-4"></div>
                          <div className="m-2  w-full  bg-slate-200 h-4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </TabsContent>
            <TabsContent value="past">
              <div
                className=" flex-1 overflow-scroll hideScroll   flex flex-col "
                style={{ height: "calc(100svh - 180px)" }}
              >
                {appointments.length > 0 && !isLoading && (
                  <div className=" gap-3 md:gap-3    sm:justify-normal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {appointments.map((e, index) => (
                      <AppointmentCard
                        key={index}
                        id={e?.id}
                        date={e?.start_time}
                        doctorName={`${e?.user?.name_prefix} ${e?.user?.profile?.first_name}
                 ${e?.user?.profile?.middle_name}
                 ${e?.user?.profile?.last_name}`}
                        specialities={e?.user?.specialities}
                        qualifications={e?.user?.qualifications}
                        type={e?.appointment_type}
                        status={e?.status}
                        tab="past"
                      />
                    ))}
                  </div>
                )}
                {isLoading && (
                  <div className="relative">
                    <div className=" gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                      {" "}
                      <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                        <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                        <div className="flex flex-col w-full">
                          <div className="m-2 w-full  bg-slate-200 h-4"></div>
                          <div className="m-2  w-full  bg-slate-200 h-4"></div>
                        </div>
                      </div>
                      <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                        <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                        <div className="flex flex-col w-full">
                          <div className="m-2 w-full  bg-slate-200 h-4"></div>
                          <div className="m-2  w-full  bg-slate-200 h-4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </TabsContent>
            <TabsContent value="cancelled">
              <div
                className=" flex-1 overflow-scroll hideScroll   flex flex-col "
                style={{ height: "calc(100vh - 180px)" }}
              >
                {appointments.length > 0 && !isLoading && (
                  <div className=" gap-3 md:gap-3    sm:justify-normal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {appointments.map((e, index) => (
                      <AppointmentCard
                        key={index}
                        id={e?.id}
                        date={e?.start_time}
                        doctorName={`${e?.user?.name_prefix} ${e?.user?.profile?.first_name}
                 ${e?.user?.profile?.middle_name}
                 ${e?.user?.profile?.last_name}`}
                        specialities={e?.user?.specialities}
                        qualifications={e?.user?.qualifications}
                        type={e?.appointment_type}
                        status={e?.status}
                        tab="cancelled"
                      />
                    ))}
                  </div>
                )}
                {isLoading && (
                  <div className="relative">
                    <div className=" gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                      {" "}
                      <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                        <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                        <div className="flex flex-col w-full">
                          <div className="m-2 w-full  bg-slate-200 h-4"></div>
                          <div className="m-2  w-full  bg-slate-200 h-4"></div>
                        </div>
                      </div>
                      <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                        <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                        <div className="flex flex-col w-full">
                          <div className="m-2 w-full  bg-slate-200 h-4"></div>
                          <div className="m-2  w-full  bg-slate-200 h-4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </>
      <div className="bg-white h-16 fixed flex justify-center bottom-0 w-full">
        <button
          className="w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
          onClick={gotoSchedule}
        >
          Schedule appointment
        </button>
      </div>
    </div>
  );
};

export default AppointmentList;
